export default {
  "custom": {
    linkedReference: 'Référence liée',
    boot: 'Allumer',
    shutDown: 'Éteindre',
    notLinked: 'Non lié',
    maxLinkedTip: 'Maximum 2 liens {type} autorisés, rétabli automatiquement à Non lié',

    bar_Power: 'Alimentation',
    bar_Video: 'Commutation vidéo',
    bar_Vol: 'Volume',
    bar_Audio: 'Commutation audio',
    bar_Serial: 'Contrôle série',
    bar_Air: 'Climatiseur',
    bar_Projection: 'Écran de projection',
    bar_Remote: 'Télécommande',
    bar_Matrix: 'IQShare Matrix',
    youMustSelectAllThreeImagesAtTheSameTime: 'Vous devez sélectionner les trois images en même temps',
    notSelected: 'Non sélectionné',
    choose: 'Choisir',
    disable: 'Désactiver',
    "longPressAndDrag": "Appuyez longuement et faites glisser pour ajuster l'ordre de la liste",
    "isrestoreDefault": "Voulez-vous restaurer l'état par défaut ?",
    "saveAndSync": "Enregistrer et synchroniser",
    "restoreDefault": "Restaurer par défaut",
    "limitPNG": "Seules les images PNG peuvent être téléchargées !",
    "limit1M": "La taille de l'image ne doit pas dépasser 1 Mo !",
    "selectTheImage": "Sélectionner une image",
    "textsuggestions": "Recommandé : icône PNG blanche 48*48 px, moins de 1 Mo",
    "iconLibrary": "Bibliothèque d'icônes",
    "panelNavigationBarCustomization": "Barre de navigation du panneau",
    "logoCustomization": "Logo du panneau"
  },
  outlook: {
    privacy: 'Bind Microsoft Organization Privacy Agreement',
    privacyContent: "Agree to",
    AuthVerify4004One: "Échec de la liaison : ce locataire Microsoft (ID : ",
    AuthVerify4004Two: ") est déjà utilisé par l'organisation [",
    AuthVerify4004Three: "]. Pour relier, veuillez d'abord le dissocier de l'organisation d'origine ou utiliser un autre locataire Microsoft.",
    theMicrosoftTenantIsOccupied: "Le locataire Microsoft est déjà utilisé",
    Viewtutorial: "Voir le tutoriel de liaison",
    checktenantID: "Veuillez vérifier que votre ID de locataire, ID d'application et clé d'application sont corrects.",
    ErrorCode: "Code d'erreur :",
    AuthorizationFailed: "Échec de l'autorisation",
    Accesshasbeengranted: "L'accès à l'API Microsoft Graph a été accordé",
    successfullyauthorizedDescribe: "Les autorisations requises ont été accordées avec succès. Les données des salles de réunion seront synchronisées automatiquement. Veuillez fermer cette page.",
    Close: "Fermer",
    resourceID: "ID de ressource",
    dialogTips: "Conseils",
    theAuthorizationIsDeleted: "Autorisation supprimée",
    theBindingIsSuccessful: "Liaison réussie",
    theUnbindingIsSuccessful: "Déliaison réussie",
    unbindingFailed: "Échec de la déliaison",
    theUnbindingHasBeenUnbound: "Déliaison annulée",
    continueUnbinding: "La synchronisation Outlook s'arrêtera et tous les événements à venir seront effacés. Continuer la déliaison ?",
    areYouSureAboutUnbinding: "Tous les événements Outlook à venir seront effacés et la synchronisation s'arrêtera. Cette action est irréversible. Confirmer la déliaison ?",
    UnbindNotSynchronized: "Après la liaison, les nouveaux événements Outlook pour cette salle seront synchronisés automatiquement (les événements passés ne seront pas synchronisés)",
    unbinding: "Délier",
    bindUnableToSelect: "Déjà lié, sélection impossible",
    permissAThird: "Veuillez autoriser la liaison des ressources tierces",
    resourceMailbox: "Boîte aux lettres de ressource :",
    PleasecheckID: "Échec de l'autorisation ! Veuillez vérifier que votre ID de locataire, ID d'application et secret client sont corrects.",
    Waitingforauthorization: "En attente d'autorisation...",
    Pleasecompletetheauthorization: "La page de connexion Microsoft 365 est ouverte. Veuillez vous connecter avec un compte administrateur pour terminer l'autorisation.",
    pleaseEnterTheTenantID: "Veuillez entrer l'ID de locataire",
    pleaseEnterTheClientID: "Veuillez entrer l'ID d'application",
    pleaseEnterTheClientSecret: "Veuillez entrer le secret client",
    Authorizationcompleted: "Autorisation terminée",
    Authorizelogin: "Autoriser la connexion Microsoft 365",
    ApplicationID: "ID de locataire",
    ClientID: "ID d'application",
    ClientSecret: "Secret client",
    registTipOne: "Veuillez suivre le",
    registTipTwo: "Guide de liaison",
    registTipThree: "Complétez l'enregistrement de l'application Azure et les paramètres d'autorisation avant de remplir les champs ci-dessous.",
    MicrosoftDescribe: "En liant Microsoft 365, les réunions réservées dans Outlook/Teams seront automatiquement synchronisées avec la console Q-NEX et le planificateur de salles.",
    Addcalendarservice: "Paramètres de synchronisation du calendrier",
    Lasttimesynchronization: "Dernière synchronisation",
    Allocated: "Attribué",
    Total: "Total",
    Conferenceroomresources: "Ressources des salles de réunion",
    Bindingtime: "Heure de liaison",
    Bindtheplatform: "Plateforme de liaison",
    Synchronousstate: "État de synchronisation",
    Organizationname: "Nom de l'organisation",
    Bindthirdpartycalendar: "Lier un calendrier tiers",
    TenantIDTip: "Identifiant unique dans Azure AD",
    ApplicationIDTip: "ID d'application enregistré dans Azure",
    ApplicationSecretTip: "Secret client généré dans Azure pour l'authentification"
  },
  "meetingManager": {
    IdleDisplayTextTable: 'Texte d’affichage en veille',
    IdleDisplayText: 'Texte d’affichage en veille :',
    IdleDisplayTextContent: 'Texte affiché lorsque la salle est vide (par défaut : « Vacant »)',

    duplicateMeetingRoomName: 'Nom de salle de réunion en double',
    duplicateMeetingRoomNameContent: 'Une salle de réunion nommée « {duplicate_content} » existe déjà. Veuillez en saisir un autre.',
    NumberOfRoomPanels: 'Nombre de panneaux de salle',
    "Thecurrentterminalhasbeenboundtoanotherorganization": "Le terminal actuel est déjà lié à une autre organisation.",
    "theTerminalNameOrIDIsDuplicated": "Le nom ou l'ID du panneau est le même",
    theRoomNameOrIDIsDuplicated: 'Le nom de la salle de réunion ou l’emplacement est déjà utilisé.',
    "AddMeetingRoom": "Ajouter une salle de réunion",
    "EditMeetingRoom": "Modifier la salle de réunion",
    "MeetingRoomName": "Nom de la salle de réunion :",
    "Location": "Emplacement :",
    "ReservationApproval": "Approbation de la réservation :",
    "ApprovalListYes": "oui",
    "ApprovalListNo": "non",
    "Capacity": "Capacité :",
    "RoomStatus": "Statut de la salle :",
    "BindRoomDisplay": "Associer le panneau de la salle :",
    "meeting_btnAdd": "Ajouter",
    "meeting_btnEdit": "Modifier",
    "meeting_btnBind": "Associer un appareil",
    "meeting_btnDel": "Supprimer",
    "meeting_tableRoomName": "Nom de la salle de réunion",
    "meeting_tableRoomPlace": "Emplacement",
    "meeting_tableAppointmentApproval": "Approbation de la réservation",
    "meeting_tableCapacityForPeople": "Capacité",
    "meeting_tableMeetingRoomStatus": "Statut de la salle",
    "meeting_tableAvaliable": "Disponible",
    "meeting_tableOutofService": "Hors service",
    "meeting_tableDoorBind": "Associer la porte",
    "meeting_tableBindNPS": "Associer le NPS",
    "meeting_tableActions": "Actions",
    "door_theNameOfTheTerminal": "Nom du panneau :",
    "door_deviceID": "ID du panneau :",
    "door_Wallpaper": "Fond d'écran :",
    "door_Wallpaper_text": "Image recommandée : taille 1280x800, au format PNG",
    "door_bindAMeetingRoom": "Associer la salle de réunion :",
    "door_table_name": "Nom du panneau",
    "door_table_deviceID": "ID du panneau",
    "door_table_status": "Statut",
    "door_table_ipAddress": "Adresse IP",
    "door_table_bindAMeetingRoom": "Associer la salle de réunion",
    "door_btnAdd": "Ajouter",
    "door_btnBatchAdd": "Ajouter par lot",
    "door_btnEdit": "Modifier",
    "door_btnBatchEdit": "Modifier par lot"
  },
  "InputSourcesLinkage": {
    "configurationAddTitle": "Ajouter une configuration",
    "configurationEditTitle": "Modifier la configuration",
    "dialogConfigName": "Nom de la configuration",
    "selectNMPAndNDP": "Appareils cibles",
    "powerControl": "Contrôle de l'alimentation",
    "executeCommand": "Faire",
    "tableConfigName": "Nom de la configuration",
    "selectConfig": "Veuillez sélectionner la configuration"
  },
  "NPS": {
    "Relay": "Relais",
    "RelaySettings": "Paramètres du relais",
    "DevicePower": "Contrôle de l'alimentation de l'appareil",
    "DeviceElevation": "Contrôle de l'élévation",
    "LinageWithNPSPower": "Liaison avec l'alimentation NPS",
    "PresentationSwitch": "Commutateur de présentation",
    "Duplicate": "Dupliquer",
    "LinkagewithNPSPowe": "Liaison avec l'alimentation NPS"
  },
  "PTZ": {
    "powerSupplyON": "Allumer",
    "powerSupplyOFF": "Éteindre",
    "LEFT": "Gauche",
    "RIGHT": "Droite",
    "UP": "Haut",
    "DOWN": "Bas",
    "HOME": "Accueil",
    "ENLARGE": "Agrandir",
    "REDUCTION": "Réduire",
    "StopMovement": "Arrêter le mouvement",
    "STOP": "Arrêter le zoom",
    "FOCUS": "Mise au point",
    "SET_PRESETS0": "RÉGLER_PRÉSET0",
    "SET_PRESETS1": "RÉGLER_PRÉSET1",
    "SET_PRESETS2": "RÉGLER_PRÉSET2",
    "SET_PRESETS3": "RÉGLER_PRÉSET3",
    "SET_PRESETS4": "RÉGLER_PRÉSET4",
    "SET_PRESETS5": "RÉGLER_PRÉSET5",
    "SET_PRESETS6": "RÉGLER_PRÉSET6",
    "SET_PRESETS7": "RÉGLER_PRÉSET7",
    "SET_PRESETS8": "RÉGLER_PRÉSET8",
    "SET_PRESETS9": "RÉGLER_PRÉSET9",
    "USE_PRESETS0": "UTILISER_PRÉSET0",
    "USE_PRESETS1": "UTILISER_PRÉSET1",
    "USE_PRESETS2": "UTILISER_PRÉSET2",
    "USE_PRESETS3": "UTILISER_PRÉSET3",
    "USE_PRESETS4": "UTILISER_PRÉSET4",
    "USE_PRESETS5": "UTILISER_PRÉSET5",
    "USE_PRESETS6": "UTILISER_PRÉSET6",
    "USE_PRESETS7": "UTILISER_PRÉSET7",
    "USE_PRESETS8": "UTILISER_PRÉSET8",
    "USE_PRESETS9": "UTILISER_PRÉSET9"
  },
  "schedule": {
    "startLinkPowerStart": "Allumer (Relais CBXs)  ",
    "startLinkPowerStop": "Éteindre (Relais CBXs)  ",
    "dehumidification": "Sec  ",
    "airSupply": "Ventilateur  ",
    "masterControl": "principal :  ",
    "powerSupply": "Alimentation  ",
    "lockScreen": "Verrouillage  ",
    "RecordingControl": "Contrôle d'enregistrement  ",
    "RecordingControlSystem": "Système de capture de cours  ",
    "LiquidCrystal": "Panneau interactif à écran plat  ",
    "projector": "Projecteur  ",
    "othertype": "Autre  ",
    "childLock": "Verrouillage enfant  ",
    "energySaving": "Économie d'énergie  ",
    "signalSourceSwitching": "Source d'entrée  ",
    "other": "Autres fonctionnalités :  ",
    "otherFunction": "Fonction  ",
    "send": "Envoyer  ",
    "ON": "ACTIVER  ",
    "OFF": "DÉSACTIVER  ",
    "btnAddSchedule": "Restaurer  ",
    "EditSchedulelist": "Modifier le planificateur  ",
    "AddSchedulelist": "Ajouter un planificateur  ",
    "RestoreSchedulelist": "Restaurer  ",
    "btn": "Annuler  ",
    "btnNewList": "Nouveau planificateur  ",
    "ListName": "Nom  ",
    "Cannotquit": "Obligatoire  ",
    "NOCannotquit": "NON  ",
    "ListValidityPeriod": "Période de validité  ",
    "ListDescription": "Description  ",
    "currentSchedule": "Liste des planificateurs  ",
    "historySchedule": "Liste des historiques  ",
    "selectTime": "Heure  ",
    "taskType": "Type de tâche  ",
    "selectBroadcasting": "Diffusion  ",
    "selectDeviveControl": "Contrôle de l'appareil  ",
    "newSchedule": "Nouvelle tâche  ",
    "newChecklist": "Nouvelle liste de contrôle  ",
    "titleStatus": "Statut  ",
    "titleType": "Type  ",
    "titleStartTime": "Heure de début  ",
    "titleEndTime": "Heure de fin  ",
    "titleRepeat": "Répéter  ",
    "titleName": "Nom  ",
    "titleAction": "Action  ",
    "tableEnabled": "Activé  ",
    "tablePaused": "En pause  ",
    "tableEdit": "Modifier  ",
    "tableDelete": "Supprimer",
    "tableVolumeEdit": "Volume de diffusion  ",
    "tableBroadcastTitle": "Titre  ",
    "tableBroadcastContent": "Contenu  ",
    "tableBroadcastList": "Liste  ",
    "tableBroadcast": "Obsessionnel  ",
    "btnRemoveCompletely": "Supprimer complètement  ",
    "btnEnabled": "Activé  ",
    "btnPaused": "En pause  ",
    "btnDelete": "Supprimer  ",
    "repeat0": "LUN  ",
    "repeat1": "MAR  ",
    "repeat2": "MER  ",
    "repeat3": "JEU  ",
    "repeat4": "VEN  ",
    "repeat5": "SAM  ",
    "repeat6": "DIM  ",
    "dialogTitleAdd": "Nouvelle tâche de contrôle de l'appareil  ",
    "dialogTitleEdit": "Modifier la tâche de contrôle de l'appareil  ",
    "newBroadcastingSchedule": "Nouvelle tâche de diffusion  ",
    "editBroadcastingSchedule": "Modifier la tâche de diffusion  ",
    "chooseDevice": "Choisir un appareil  ",
    "timeSetting": "Réglage de l'heure  ",
    "controlBroadcasting": "Option de diffusion  ",
    "controlOption": "Option de contrôle  ",
    "scheduleName": "Nom de la tâche :  ",
    "destination": "Destination  ",
    "timeTilte": "Temps  ",
    "repeatTitle": "Répéter  ",
    "dialogRepeat0": "LUN  ",
    "dialogRepeat1": "MAR  ",
    "dialogRepeat2": "MER  ",
    "dialogRepeat3": "JEU  ",
    "dialogRepeat4": "VEN  ",
    "dialogRepeat5": "SAM  ",
    "dialogRepeat6": "DIM  ",
    "dialogOnceType": "Une fois  ",
    "dialogRepeatType": "Répéter  ",
    "mainPower": "Alimentation principale  ",
    "powerControl": "Contrôle de l'alimentation  ",
    "tableDisplayInputSwitch": "Commutateur d'entrée d'affichage  ",
    "tableAirConditioning": "Climatisation  ",
    "tableProjectionScreen": "Écran de projection  ",
    "tableElectronicLock": "Verrouillage électrique  ",
    "interactiveFlatPanel": "Panneau interactif à écran plat  ",
    "displayInputSwitch": "Commutateur d'entrée d'affichage  ",
    "speakerVolume": "Volume des haut-parleurs  ",
    "MICVolume": "Volume du micro  ",
    "ProjectionScreen": "Écran de projection  ",
    "ElectronicLock": "Verrouillage électrique  ",
    "AirConditioning": "Climatisation",
    "AirConditioningPower": "Puissance  ",
    "AirConditioningModel": "Modèle  ",
    "AirConditioningTEMP": "TEMP  ",
    "AirConditioningFanSpeed": "Vitesse du ventilateur  ",
    "OPEN": "OUVERT  ",
    "CLOSE": "FERMÉ  ",
    "UP": "HAUT  ",
    "DOWN": "BAS  ",
    "PowerOFF": "ÉTEINT  ",
    "PowerON": "ALLUMÉ  ",
    "ModelAuto": "Auto  ",
    "ModelCool": "Refroidir  ",
    "ModelHeat": "Chauffer  ",
    "ModelAir": "Côté air  ",
    "TEMPLow": "Faible  ",
    "TEMPMiddle": "Moyenne  ",
    "TEMPHigh": "Élevée  ",
    "btnSave": "Enregistrer  ",
    "btnNext": "SUIVANT  ",
    "StartTime": "Heure de début  ",
    "StopTime": "Heure de fin  ",
    "Mandatory": "Obligatoire  ",
    "Video": "Vidéo & Audio  ",
    "Notification": "Notification  ",
    "btnFile": "Sélectionner un fichier multimédia  ",
    "LastingTime": "Durée  ",
    "textTitle": "Titre  ",
    "textContent": "Contenu  ",
    "textTitleLetters": "Moins de 60 lettres  ",
    "textContentLetters": "Moins de 320 lettres  ",
    "CannotquitYES": "OUI  ",
    "CannotquitNo": "Non  ",
    "YES": "OUI  ",
    "No": "Non  ",
    "delTitleContent": "Êtes-vous sûr de vouloir supprimer ce planificateur ?  ",
    "delTitleListContent": "Le planificateur supprimé sera déplacé vers la liste d'historique et pourra être restauré  ",
    "deleListTitle": "Supprimer le planificateur ?  ",
    "delTitleListContent1": "La suppression du planificateur entraînera l'effacement des tâches associées, veuillez confirmer.  ",
    "deleListTitle1": "Êtes-vous sûr de vouloir supprimer ce planificateur ?  ",
    "delTitle": "Supprimer ?  ",
    "btnConfirm": "Confirmer  ",
    "coxAll": "TOUS  ",
    "coxBroadcasting": "Diffusion  ",
    "coxDeviveControl": "Contrôle de l'appareil  ",
    "rdMandatory": "OUI  ",
    "noRdMandatory": "NON  ",
    "startDate": "Date de début  ",
    "endedDate": "Date de fin  ",
    "or": "-  ",
    "broadcastingType": "Type",
    "ChooseTime": "Choisir l'heure  ",
    "ChooseDate": "Choisir la date  ",
    "newScheduleList": "Nouveau programme  ",
    "editScheduleList": "Modifier le programme  ",
    "listName": "Nom  ",
    "listValidityPeriod": "Période de validité  ",
    "listDescription": "Description  ",
    "cancel": "Annuler  ",
    "confirm": "Confirmer  ",
    "save": "Enregistrer  ",
    "addSuccess": "Ajout réussi !  ",
    "addError": "Échec de l'ajout !  ",
    "editSuccess": "Modification réussie !  ",
    "editError": "Échec de la modification !  ",
    "delSuccess": "Suppression réussie !  ",
    "delError": "Échec de la suppression !  ",
    "restoreSuccess": "Liste des programmes restaurée avec succès  ",
    "restoreError": "Échec de la récupération de la liste des programmes  ",
    "restoreTitleContent": "Ce horaire entre en conflit avec un horaire dans la liste, veuillez sélectionner à nouveau  ",
    "Enabled": "Activé  ",
    "Paused": "En pause  ",
    "Title": "Titre :  ",
    "Content": "Contenu :  ",
    "errorScheduleNameRequired": "Le nom de la tâche doit être rempli  ",
    "errorDeviceRequired": "Veuillez sélectionner le périphérique cible  ",
    "deleTitle": "Êtes-vous sûr de vouloir supprimer cette tâche ?  ",
    "loopList": "Liste des boucles  ",
    "errorPleaseDateRange": "Veuillez sélectionner une plage de dates  ",
    "addError_2009": "Nom du programme en double  ",
    "conflicts": "Le temps de la tâche entre en conflit avec les suivants :  ",
    "Pleaseagain": "Veuillez entrer à nouveau  ",
    "errorScheduleName": "Nom de la tâche  ",
    "errorListName": "Nom du programme  ",
    "today": "Aujourd'hui  ",
    "yesterday": "Hier  ",
    "thisWeek": "Cette semaine  ",
    "lastWeek": "La semaine dernière  ",
    "lastMonth": "Le mois dernier  ",
    "thisMonth": "Ce mois-ci  ",
    "times": "Times  ",
    "TimeConflicts": "Conflits de temps  ",
    "editError_2006": "Le périphérique n'a pas été trouvé  ",
    "editError_2010": "Nom de la tâche en double  ",
    "ListTimeExpired": "Le temps du programme a expiré, veuillez sélectionner à nouveau  ",
    "TimeExpired": "Temps expiré  ",
    "ControlOption": "L'option de contrôle est manquante  ",
    "Pleaseleastone": "Veuillez sélectionner au moins une option de contrôle  ",
    "Enter": "Entrer  ",
    "TitleFilled": "Le titre doit être rempli  ",
    "ContentFilled": "Le contenu doit être rempli  ",
    "PleaseMediaFile": "Veuillez sélectionner un fichier multimédia  ",
    "PleaseSchedule": "Veuillez sélectionner une tâche  ",
    "delTitleScheduleContent": "La tâche supprimée ne peut pas être récupérée.  ",
    "deleTitleSchedule": "Êtes-vous sûr de vouloir supprimer cette tâche ?  ",
    "deleteScheduleTitle": "Veuillez sélectionner la tâche à supprimer  ",
    "PleaseFillColumn": "Veuillez remplir le nom du programme  ",
    "PleaseDate": "Veuillez sélectionner la date  ",
    "Previous": "Précédent  ",
    "RemoteControl": "Télécommande  ",
    "taskhasexpired": "Cette tâche a expiré, veuillez contacter le créateur pour mettre à jour l'heure.  ",
    "execute": "Exécuter  ",
    "broadcastingList": "Liste de diffusion  ",
    "volumeSuccess": "Volume réglé avec succès  ",
    "volumeFailed": "Échec du réglage du volume  "
  },
  "Automation": {
    "nameDuplicate": "Nom de la tâche dupliqué automatiquement  ",
    "Automation": "Automatisation  ",
    "if": "Si :  ",
    "ifContent": "La section 'SI' vous permet de définir des conditions basées sur les données des capteurs. Choisissez le capteur et spécifiez des conditions telles que 'Température > 26°C'.  ",
    "then": "Alors :  ",
    "thenContent": "La section 'ALORS' vous permet de choisir des appareils et de définir des actions pour eux. Sélectionnez des appareils comme NMP1, NMP2 et spécifiez des actions telles que 'Allumer + Refroidir' pour les climatiseurs.  ",
    "btnDelete": "Supprimer  ",
    "Add": "Ajouter  ",
    "taskName": "Nom de la tâche  ",
    "dialogTaskName": "Nom de la tâche :  ",
    "Statue": "Statut  ",
    "DevicesApplied": "Appareils appliqués  ",
    "Operation": "Opération  ",
    "AirConditioningPower": "Alimentation  ",
    "AirConditioningModel": "Modèle  ",
    "AirConditioningFanSpeed": "Vitesse du ventilateur  ",
    "bold": "Oscillation  ",
    "selectTask": "Veuillez sélectionner la tâche  ",
    "autoTaskAdd": "Ajouter une tâche d'automatisation  ",
    "autoTaskEdit": "Modifier une tâche d'automatisation  ",
    "Destination": "Destination  ",
    "selectConditions": "Veuillez spécifier l'action que vous souhaitez effectuer.  ",
    "selectDestination": "Veuillez sélectionner le(s) appareil(s) cible(s) NMP, puis spécifiez l'action que vous souhaitez effectuer  ",
    "AirConditioningTEMP": "Température  ",
    "AirConditioningHumidness": "Humidité  ",
    "noData": "Aucune tâche ajoutée pour le moment. Cliquez sur \"Ajouter\" pour ajouter des tâches.  "
  },
  "rs232Translation": {
    "reliveBinding": "Dissocier  ",
    "RELIVEBINDING": "Dissocier",
    "ACTO": "ACTO",
    "AMENA": "AMENA",
    "APPOTRONICS": "APPOTRONICS",
    "APTI": "APTI",
    "ASEE": "ASEE",
    "ASK": "ASK",
    "AUCMA": "AUCMA",
    "AUX": "AUX",
    "BARCO": "BARCO",
    "BENQ": "BENQ",
    "BOERKA": "BOERKA",
    "BOXLIGHT": "BOXLIGHT",
    "Canon": "Canon",
    "CARRIER": "CARRIER",
    "CHANGHONG": "CHANGHONG",
    "CHIGO": "CHIGO",
    "CHRISTIE": "CHRISTIE",
    "Chunlan": "Chunlan",
    "COSTAR": "COSTAR",
    "CROWN": "CROWN",
    "CX": "CX",
    "DAEWOO": "DAEWOO",
    "DAIKIN": "DAIKIN",
    "DIGITEL": "DIGITEL",
    "DONGBAO": "DONGBAO",
    "EIKI": "EIKI",
    "electra": "electra",
    "Electrolux": "Electrolux",
    "EPSON": "EPSON",
    "FEILU": "FEILU",
    "FOUNDER": "FOUNDER",
    "Frestec": "Frestec",
    "Fujitsu": "Fujitsu",
    "Galanz": "Galanz",
    "GREE": "GREE",
    "Haier": "Haier",
    "Hisense": "Hisense",
    "HITACHI": "HITACHI",
    "HP": "HP",
    "HUIFENG": "HUIFENG",
    "InFocus": "InFocus",
    "IQ": "IQ",
    "JVC": "JVC",
    "KODAK": "KODAK",
    "LANGER": "LANGER",
    "LENOVO": "LENOVO",
    "LG": "LG",
    "LITTLESWAN": "LITTLESWAN",
    "LUMENS": "LUMENS",
    "McQuay": "McQuay",
    "Microtek": "Microtek",
    "Mitsubishi": "Mitsubishi",
    "NANFENG": "NANFENG",
    "NEC": "NEC",
    "OPTOMA": "OPTOMA",
    "PALOROID": "PALOROID",
    "panisonic": "panisonic",
    "PHILIP": "PHILIP",
    "PJD": "PJD",
    "PLUS": "PLUS",
    "POLAROID": "POLAROID",
    "PROPIX": "PROPIX",
    "PROXIMA": "PROXIMA",
    "RAYBO": "RAYBO",
    "ROWA": "ROWA",
    "Samsung": "Samsung",
    "SANYO": "SANYO",
    "SAST": "SAST",
    "SEEMILE": "SEEMILE",
    "SHARP": "SHARP",
    "shengfeng": "shengfeng",
    "Shinco": "Shinco",
    "shuanglu": "shuanglu",
    "Sony": "Sony",
    "SOVA": "SOVA"
  },
  "VcbEdit": {
    "VcbNameNoNull": "Le nom du CBX ne peut pas être vide  ",
    "BrandNoNull": "La marque ne peut pas être vide  ",
    "ModelNoNull": "Le modèle ne peut pas être vide  ",
    "AcNoNull": "Le contrôle de la climatisation ne peut pas être vide  ",
    "RcNoNull": "La télécommande ne peut pas être vide"
  },
  "route": {
    customize: 'Personnaliser',
    "InputSourcesLinkage": "Lien des sources d'entrée  ",
    "Automation": "Automatisation  ",
    "dashboard": "Dashboard",
    "i18n": "I18n  ",
    "organizationMge": "Groupes  ",
    "userMge": "Utilisateurs  ",
    "authorityMge": "Permission  ",
    "roleMge": "Rôles  ",
    "equipmentMge": "Appareils  ",
    "workstationMge": "Média",
    "cloudDiskMge": "Stockage",
    "operationLog": "Journal des opérations  ",
    "setting": "Paramètres  ",
    "resourceMge": "Gestion des ressources  ",
    "storageMge": "Gestion du stockage  ",
    "interfaceRename": "Renommer l'interface  ",
    "processorManager": "Gestionnaire de processeur  ",
    "projectorCode": "Gestion des codes série  ",
    "projectorCodeSetting": "Paramètres des codes série  ",
    "RepairLog": "Journal de réparation  ",
    "remoteControl": "Code de télécommande  ",
    "acCode": "Code de contrôle de la climatisation  ",
    "cardMge": "Cartes  ",
    "cardLog": "Journal d'utilisation des cartes  ",
    "cardManager": "Gestionnaire de cartes  ",
    "meetingManager": "Réunion  ",
    "meetingRoomManager": "Gestion des salles  ",
    "meetingDoorManager": "Gestion des panneaux"
  },
  "navbar": {
    "logOut": "Déconnexion  ",
    "dashboard": "Tableau de bord  ",
    "screenfull": "Plein écran  ",
    "language": "Langue  ",
    "userConsole": "Console Q-NEX  ",
    "BackTianwa": "Retour à Tianwa"
  },
  "feedback": {
    "Feedback": "Retour d'information  ",
    "email": "Veuillez laisser votre e-mail pour notre retour.  ",
    "content": "Bienvenue et laissez des messages pour améliorer nos produits. Merci pour vos commentaires.  ",
    "submit": "Soumettre  ",
    "emailNoEmpty": "L'e-mail ne peut pas être vide  ",
    "emailTrueRule": "Veuillez entrer un format d'e-mail correct  ",
    "contentNoEmpty": "Le contenu ne peut pas être vide  ",
    "feedbackSuccess": "Retour d'information réussi  ",
    "feedbackFailed": "Échec du retour d'information  ",
    "emailNoChinese": "La boîte aux lettres ne peut pas contenir de caractères chinois  ",
    "emailLength": "Entre 5 et 100 caractères de longueur  ",
    "GroupNameLength": "Entre 1 et 20 caractères de longueur  ",
    "emailSpecialString": "Cette zone de saisie ne peut pas contenir de chaînes spéciales"
  },
  "login": {
    "title": "BIENVENUE  ",
    "logIn": "Se connecter  ",
    "username": "Nom d'utilisateur  ",
    "password": "Mot de passe  ",
    "any": "tout  ",
    "thirdparty": "Ou se connecter avec  ",
    "thirdpartyTips": "Impossible de simuler en local, alors veuillez combiner votre propre simulation d'affaires !!!  ",
    "placeholder": "[  \n  \"Nom d'utilisateur\",  \n  \"Mot de passe\",  \n  \"Code de vérification\"  \n]  ",
    "userNameTitle": "Nom d'utilisateur incorrect !  ",
    "forget": "L'avez-vous oublié ?  ",
    "loginTitle0": "Connexion réussie !  ",
    "loginTitle1000": "Nom d'utilisateur ou mot de passe incorrect !  ",
    "loginTitle1001": "Le nom d'utilisateur et le mot de passe doivent être remplis !  ",
    "loginTitle1002": "Le code de vérification doit être rempli !  ",
    "loginTitle1003": "Le statut de l'utilisateur est illégal, échec de la connexion !  ",
    "loginTitle1004": "Erreur de code de vérification !  ",
    "loginTitle1005": "Non connecté, veuillez vous connecter d'abord !  ",
    "loginTitleUserName": "Le nom d'utilisateur doit être rempli !  ",
    "loginTitlePwd": "Le mot de passe doit être rempli !  ",
    "loginTitleVercode": "Le code de vérification doit être rempli !  ",
    "errorLogin": "Droits d'utilisateur insuffisants, impossible de se connecter !  ",
    "titleLoginNameFormat": "Il doit être constitué de caractères ou de caractères et de chiffres."
  },
  "organizationMge": {
    "CanTDragTop": "Impossible de se déplacer vers la racine  ",
    "prefixCannotBeEmpty": "Le préfixe du compte super administrateur ne peut pas être vide  ",
    "enterEnglishLetters": "Le préfixe du compte super administrateur ne peut contenir que des lettres anglaises et des chiffres  ",
    "dateNotSelected": "La date de début de la période de validité du service de streaming n'est pas sélectionnée  ",
    "btnAddChild": "Ajouter un subordonné  ",
    "btnAddSibling": "Ajouter un frère  ",
    "title": "Astuce :  ",
    "againTitle": "Veuillez confirmer à nouveau :  ",
    "sort": "Trier :  ",
    "realName": "Nom réel :  ",
    "titleShooleRq": "Ce champ doit être rempli  ",
    "titleShooleNub": "moins de 100 caractères  ",
    "schoolName": "Nom du groupe :  ",
    "type": "Type de groupe :  ",
    "accountPrefix": "Compte administrateur :  ",
    "organization": "Distributeur  ",
    "terminalMechanism": "Utilisateur final  ",
    "equipmentNum": "Numéro de périphérique :  ",
    "organizationNum": "Numéro de groupes de terminaux :  ",
    "adminName": "Compte administrateur :  ",
    "adminPwd": "Mot de passe administrateur :  ",
    "edit": "Modifier  ",
    "add": "Ajouter  ",
    "del": "Supprimer  ",
    "addSuccess": "Ajout réussi  ",
    "addError": "Échec de l'ajout !  ",
    "editSuccess": "Modifié avec succès  ",
    "editError": "Échec de la modification !  ",
    "delSuccess": "Suppression réussie !  ",
    "delWarn": "Impossible de supprimer ce groupe avec des périphériques liés  ",
    "delError": "Échec de la suppression !  ",
    "cancel": "Annuler  ",
    "confirm": "Confirmer  ",
    "save": "Sauvegarder  ",
    "TrialWorkstation": "Vous êtes actuellement en période d'essai, vous ne pouvez diffuser et diffuser en direct que sur un maximum de 3 appareils terminaux.  ",
    "Normal": "Normal  ",
    "NormalWorkstation": "La période de validité de votre service de streaming est du  ",
    "to": "au  ",
    "Advent": "Avent  ",
    "AdventWorkstationOne": "Votre service de streaming expirera le  ",
    "AdventWorkstationTwo": ", veuillez contacter votre agent pour renouveler à temps pour un usage normal.  ",
    "Expired": "Expiré  ",
    "ExpiredWorkstation": "Votre service de streaming a expiré, veuillez contacter votre agent pour renouveler à temps.  ",
    "admin": "Administrateur :  ",
    "serviceState": "Service de médias en streaming :  ",
    "serviceStateLIST": "Service de médias en streaming  ",
    "ValidityPeriod": "Période de validité :  ",
    "ValidityPeriodLIST": "Période de validité  ",
    "Trial": "Essai  ",
    "Permanent": "Permanent  ",
    "AnnualBilling": "Facturation annuelle  ",
    "mediaValidityPeriod": "Période de validité :  ",
    "mediaValidityPeriodLIST": "Période de validité  ",
    "contactInformation": "Coordonnées (pour le rappel de renouvellement du service de streaming)  ",
    "company": "Nom de l'entreprise :  ",
    "email": "E-mail :  ",
    "phone": "Téléphone :  ",
    "StartDate": "Date de début  ",
    "EndDate": "Date de fin  ",
    "To": "À  ",
    "TerminalName": "Nom de l'utilisateur final  ",
    "Competence": "Administrateur  ",
    "operate": "Opérer  ",
    "statusFilter": "Filtre de statut  ",
    "disableStreaming": "Êtes-vous sûr de vouloir désactiver le service de streaming ?  ",
    "enableStreaming": "Êtes-vous sûr de vouloir activer le service de streaming ?  ",
    "disableStreamingContent": "Lorsque le service de streaming est désactivé, le groupe ne pourra pas utiliser les fonctions liées à la diffusion et à la diffusion en direct.  ",
    "enableStreamingContent": "Veuillez modifier la période de validité pour les groupes avec un service de streaming expiré.  ",
    "search": "Entrez le nom de l'organisation  ",
    "optionsYearZero": "Veuillez choisir",
    "optionsYearOne": "Un an  ",
    "optionsYearTwo": "Deux ans  ",
    "optionsYearThree": "Trois ans  ",
    "dialogName": "Nom :  ",
    "detTitle": "Supprimer le groupe entraînera la suppression de tout le contenu qui y est associé.  ",
    "groupDelTitle": "Êtes-vous sûr de vouloir supprimer ce groupe ?  ",
    "delTitle": "Supprimer ?  ",
    "delTitleContent": "Le contenu sélectionné sera supprimé de la base de données. Cette opération ne peut pas être annulée. Êtes-vous sûr de vouloir continuer ?  ",
    "delCancelButton": "Annuler  ",
    "delConfirmButton": "Confirmer  ",
    "copySuccess": "Le contenu a été copié dans le presse-papiers.  ",
    "copyError": "Le navigateur ne prend pas en charge la copie automatique  ",
    "error1200": "Nom de groupe dupliqué  ",
    "error1201": "Duplication de groupe ou ID de groupe  ",
    "error1202": "Le nombre maximal d'appareils connectés a été dépassé  ",
    "error1203": "Nom d'utilisateur dupliqué  ",
    "error1204": "Il existe un groupe avec le même nom au même niveau  ",
    "error1210": "Veuillez entrer le mot de passe de l'administrateur  ",
    "warningGroup": "Choisissez un groupe !  ",
    "warningTerminal": "Le groupe terminal ne peut pas créer de sous-groupes !  ",
    "account": "Compte dupliqué  ",
    "titleOrganization": "Remarque : Le préfixe du compte est défini au niveau de l’organisation. Tous les comptes utilisateurs de cette organisation partageront le même préfixe.",
    "all": "Tout"
  },
  "userMge": {
    "nickName": "Surnom  ",
    "contentWithBrand": "Entrez la marque ou le modèle  ",
    "contentwithIp": "Rechercher par nom de périphérique ou adresse IP.  ",
    "btnAdd": "Nouvel utilisateur  ",
    "btnDelete": "Supprimer  ",
    "btnDownload": "Télécharger le modèle  ",
    "btnImport": "Importation en masse  ",
    "btnExport": "Télécharger  ",
    "btnDisable": "Désactiver  ",
    "btnEnable": "Activer  ",
    "accountType": "Filtrer par rôle  ",
    "organizationName": "Filtrer par groupe  ",
    "content": "Rechercher  ",
    "systemAccount": "ID utilisateur  ",
    "idCardNumber": "ID employé  ",
    "customizeAccount": "Compte personnalisé  ",
    "userName": "Nom  ",
    "licenseNum": "Numéro de licence  ",
    "phone": "Téléphone  ",
    "email": "E-mail  ",
    "role": "Rôle  ",
    "status": "Statut  ",
    "affiliatedOrganization": "Groupes  ",
    "roleTypeList1": "Utilisateur général  ",
    "roleTypeList2": "Étudiant  ",
    "roleTypeList3": "Parent  ",
    "roleTypeList101": "Agent Admin  ",
    "roleTypeList102": "Administrateur  ",
    "roleTypeList301": "Super Admin  ",
    "userStatus1": "Actif  ",
    "userStatus2": "Bloqué  ",
    "userStatus3": "Supprimer  ",
    "operate": "Actions  ",
    "dialogName": "Surnom :  ",
    "dialogUserName": "ID utilisateur :  ",
    "dialogUserNameDefined": "Nom d'utilisateur :  ",
    "dialogPassword": "Mot de passe :  ",
    "dialogID": "ID employé :  ",
    "dialogRole": "Rôle :  ",
    "dialogEmail": "E-mail :  ",
    "dialogPhone": "Téléphone :  ",
    "dialogGroup": "Groupe :  ",
    "addUser": "Nouvel utilisateur  ",
    "editUser": "Modifier l'utilisateur  ",
    "addSuccess": "Ajout réussi !  ",
    "addError": "Échec de l'ajout !  ",
    "editSuccess": "Modification réussie !  ",
    "editError": "Échec de la modification !  ",
    "delSuccess": "Suppression réussie !",
    "delError": "Échec de la suppression !  ",
    "cancel": "Annuler  ",
    "confirm": "Confirmer  ",
    "save": "Sauvegarder  ",
    "tableDel": "Supprimer  ",
    "tableEdit": "Éditer  ",
    "selectRoles": "Sélectionner les rôles  ",
    "delTitle": "Supprimer ?  ",
    "delTitleContent": "Le contenu sélectionné sera supprimé de la base de données. Cette opération est irréversible. Êtes-vous sûr de vouloir continuer ?  ",
    "delCancelButton": "Annuler  ",
    "delConfirmButton": "Confirmer  ",
    "titleRealNameRq": "Ce champ doit être rempli  ",
    "titleRealNameFormat": "Choisissez un nom d'utilisateur qui contient uniquement des lettres et des chiffres.  ",
    checkPasswordTitleTwo: 'Veuillez définir un mot de passe d’au moins 6 caractères, comprenant des lettres et des chiffres. Les caractères spéciaux sont autorisés (sans restriction).',
    checkPasswordTitle: 'Le mot de passe doit comporter au moins 6 caractères et ne peut pas être uniquement des chiffres',
    "titlePhoneFormat": "Le téléphone ne peut contenir que des chiffres, (), + et -.  ",
    "phoneFilled": "Le téléphone doit être rempli.  ",
    "titleEmaileFormat": "Erreur de format d'email.  ",
    "emaileFilled": "L'email doit être rempli.  ",
    "titlUserNameDefinedNub": "Le nom d'utilisateur ne peut pas dépasser 30 caractères  ",
    "titlRealNameNub": "Le nom ne peut pas dépasser 30 caractères.  ",
    "titlRealNameField": "Le nom doit être rempli.  ",
    "thisPasswordField": "Le mot de passe doit être rempli.  ",
    "titlPassWordNub": "Le mot de passe doit être entre 6 et 30 caractères.  ",
    "enableStatus": "Activer l'utilisateur  ",
    "stopStatus": "Désactiver l'utilisateur  ",
    "enableContent": "Êtes-vous sûr de vouloir activer l'utilisateur ?  ",
    "stopContent": "Êtes-vous sûr de vouloir désactiver l'utilisateur ?  ",
    "error1400": "Le nom d'utilisateur existe déjà, veuillez réessayer  ",
    "error1401": "L'ID utilisateur existe déjà et l'opération a échoué !  ",
    "error1402": "Le groupe n'existe pas, l'importation a échoué !  ",
    "error1403": "Données incorrectes  ",
    "error1404": "Permissions insuffisantes  ",
    "selUser": "Veuillez sélectionner un utilisateur !  ",
    "error1405": "Échec de la récupération du rôle  ",
    "error1406": "Le format des données de l'utilisateur importé est incorrect  ",
    "error1407": "L'email existe déjà et l'opération a échoué.  ",
    "error1408": "Le téléphone existe déjà et l'opération a échoué.  ",
    "error1900": "Le paramètre d'accès est vide  ",
    "error1610": "Veuillez utiliser le rôle d'administrateur du terminal pour effectuer des opérations associées  ",
    "errorOrgIdList": "Le groupe ne peut pas être vide !  ",
    "Bindsucceeded": "Liaison réussie  ",
    "Bindfailed": "Échec de la liaison  ",
    "tableuserName": "Nom d'utilisateur  ",
    "titleDevice": "Appareil  ",
    "bindDevice": "Appareil de liaison  ",
    "Bindcontrollable": "Lier l'appareil contrôlable maintenant ?  "
  },
  "devicesMge": {
    mustChooseOne: 'Lorsque la télécommande intelligente est sélectionnée, au moins une commande de contrôle doit être choisie',
    customName: 'Nom personnalisé',
    "testAcCode": "Tester le nouveau code de contrôle A/C",
    "Online": "En ligne",
    "Offline": "Hors ligne",
    "unBindConfirm": "Confirmer pour dissocier Serial",
    "unBindConfirm485": "Confirmer pour dissocier RS485",
    "notYetBoundRS232": "L'appareil n'est pas encore lié à un code Serial. Vous pouvez aller dans Appareil > Code de contrôle Serial pour l'ajouter.",
    "RsFollowingFunctions": "Peut réaliser les fonctions suivantes via les codes Serial :",
    "Unbind": "Dissocier",
    "Limit255": "Le nom du fichier contient un maximum de 255 caractères",
    "clear": "Effacer",
    "equipName": "Nom de l'appareil",
    "equipType": "Type",
    "selectField": "Veuillez sélectionner un fichier",
    "dialogTip": "*Si la boîte de saisie à droite est vide, le contenu à gauche est affiché par défaut",
    "dialogTipSingle": "*Si un seul appareil n'est pas nommé, suivez le nom de \"TOUS\"",
    "cantDelTemplateOne": "Le CBX de",
    cantDelTemplateTwo: 'Le CBX de l’appareil « {deviceName} » est un modèle. Êtes-vous sûr de vouloir le supprimer ?',
    "templateTitle": "Remplacement du modèle",
    "templateContentOne": "Le nom de l'appareil \"",
    "templateContentTwo": " a été défini comme le modèle CBX commun. Êtes-vous sûr de définir l'appareil actuel comme modèle ?",
    "vcbNoTemplateNoSave": "Impossible de sauvegarder sans modèle",
    "vcbAcControl": "Sélectionner un appareil A/C",
    "vcbRemoteControl": "Sélectionner un appareil de télécommande",
    "vcbPOWERControl": "Contrôle de l'alimentation",
    "vcbRS232Control": "Contrôle Serial",
    "vcbIRControl": "Contrôle IR",
    "vcbSetting": "Paramètres CBX",
    "editVcb": "Édition du CBX",
    "vcbName": "Nom du CBX",
    "iot": "Contrôle du CBX",
    "saveAsTemplate": "Enregistrer comme modèle",
    saveAsTemplatereplenish: 'Sélectionnez plusieurs appareils pour utiliser ce modèle dans le Centre de contrôle',
    "Upload": "Télécharger",
    "Select": "Sélectionner",
    "InputDeviceID": "ID de l'appareil d'entrée",
    "editNameTips": "* Le contenu à gauche est affiché par défaut lorsque la boîte de saisie à droite est vide.",
    "_RS232A": "Interface un",
    "_RS232B": "Interface deux",
    "institutionDirectory": "Répertoire de l'institution",
    "projectionScreenLinkageSetting": "Paramètres de contrôle de l'écran de projection",
    "screenLiftingLinkageDisplaySwitch": "Contrôle de liaison écran de projection et affichage :",
    "stopLinkage": "Désactiver (Contrôler l'écran de projection séparément)",
    "Enable": "Activer (Contrôler simultanément l'écran de projection et l'affichage)",
    "btnAddDevice": "Ajouter un appareil",
    "btnImportDevice": "Importation en masse d'appareils",
    "btnDel": "Supprimer",
    "btnEdit": "Éditer",
    "tableIpAddress": "Adresse IP",
    "MACAddress": "Adresse MAC",
    "firmwareVersion": "Version du firmware",
    "NA": "Non applicable",
    "tableDeviceName": "Nom de l'appareil",
    "tableStatus": "Statut",
    "tableVideoSwitch": "Commutateur vidéo",
    "tableAudio": "Distribution A/V",
    "tablePowerControl": "Contrôle de l'alimentation",
    "tableRS232": "Contrôle série",
    "tableIR": "Contrôle IR",
    "tableRFIDCard": "Carte IC",
    "tableControlPanel": "Panneau de contrôle",
    "tableOrganization": "Groupes",
    "tableActions": "Actions",
    "dialogAddTitle": "Ajouter un appareil",
    "dialogEditTitle": "Éditer un appareil",
    "dialogBatchAddTitle": "Ajout en masse d'appareils",
    "dialogBatchEditTitle": "Édition en masse d'appareils",
    "btnCancel": "Annuler",
    "Devices": "Appareils :",
    "ProjectorCode": "Code Serial :",
    "Group": "Groupe :",
    "btnBatchAdd": "Ajout en masse",
    "delTitle": "Supprimer ?",
    "delTitleContent": "Les composants sélectionnés seront supprimés de la base de données. Ce processus est irréversible. Êtes-vous sûr de vouloir continuer ?",
    "delCancelButton": "Annuler",
    "delConfirmButton": "Confirmer",
    "addError": "Échec de l'ajout !",
    "editSuccess": "Édition réussie !",
    "editError": "Échec de l'édition !",
    "delSuccess": "Suppression réussie !",
    "delError": "Échec de la suppression !",
    "content": "Recherche",
    "cancel": "Annuler",
    "confirm": "Confirmer",
    "save": "Enregistrer",
    "tableDel": "Supprimer",
    "tableEdit": "Éditer",
    "selectRoles": "Sélectionner les rôles",
    "selectType": "Veuillez sélectionner un type",
    "selectDevices": "Veuillez sélectionner un appareil",
    "titleRealNameRq": "Ce champ doit être rempli",
    "titleRealNameNub": "Moins de 100 caractères",
    "titlPassWordNub": "Moins de 15 caractères",
    "error1900": "Le paramètre accédé est vide",
    "error2000": "Le nombre maximum d'appareils connectables a été dépassé",
    "error2001": "Le code de l'appareil importé est incorrect ou n'a pas encore été entré dans le système.",
    "error2002": "Nom de l'appareil dupliqué importé",
    "error2003": "L'ID de l'appareil importé a déjà été utilisé",
    "error2004": "Erreur de données importées",
    "error2005": "Le nom de la marque ou du modèle est en double avec les données existantes dans le système ; veuillez renommer la marque ou le modèle.",
    "error2008": "Cet appareil est déjà associé à un autre groupe",
    "notDevicesName": "Le nom de l'appareil ne peut pas être vide",
    "notDevicesNO": "L'ID de l'appareil ne peut pas être vide",
    "dialogDevicesName": "Nom de l'appareil :",
    "dialogDevicesID": "ID de l'appareil :",
    "dialogProjectorCode": "Code Serial :",
    "dialogGroup": "Groupe :",
    "dialogSel": "Veuillez choisir",
    "errorOrgIdList": "Le groupe ne peut pas être vide !",
    "errorDevicesName": "Le nom de l'appareil ne peut pas être vide !",
    "errorDevicesNo": "L'ID de l'appareil ne peut pas être vide !",
    "dialogTiltleDevices": "Appareils :",
    "uploadSuccess": "Téléchargement réussi",
    "addSuccess": "Ajout réussi",
    "ChooseGroups": "Choisir les groupes",
    "ChooseIcon": "Choisir une icône",
    "dialogDevicesTitle": "Les paramètres du paramètre sont appliqués aux appareils suivants",
    "backDevice": "Retour",
    "bootSetting": "Options de démarrage",
    "nmpOpenSetting": "Paramètres de mise sous tension",
    "npsOpenSetting": "Paramètres de mise sous tension",
    "nmpPowerSettings": "Paramètres d'alimentation",
    "npsPowerSettings": "Paramètres d'alimentation",
    "nmpInterfaceSettings": "Paramètres de l'interface",
    "npsInterfaceSettings": "Paramètres de l'interface",
    "nmpDefaultChannel": "Paramètres du canal par défaut",
    "nmpCloseSetting": "Paramètres d'arrêt",
    "npsCloseSetting": "Paramètres d'arrêt",
    "SwipeToStart": "Activer le verrou (toucher la carte pour déverrouiller)",
    "ControlPanelToStart": "Désactiver le verrou (opération illimitée)",
    "Display": "Afficher",
    "External": "Externe",
    "startingUpMethod": "Activer/désactiver le verrouillage du panneau :",
    "startWith": "Démarrer avec :",
    "nmpstartWith": "Mise sous tension synchronisée :",
    "nmpcloseWith": "Mise hors tension synchronisée :",
    "RS232Tip": "Lorsque l'alimentation principale est coupée, un total de 5 interfaces Serial, y compris Serial et jusqu'à 4 CBX, recevront le code de commande d'arrêt correspondant.",

    startPowerTip: 'Lors du démarrage, tous les dispositifs connectés aux interfaces d’alimentation du CBX sont activés.',
    startAirTip: 'Lors du démarrage, tous les climatiseurs liés sont allumés via l’infrarouge du dispositif/CBX.',
    startIrTip: 'Lors du démarrage, une commande de liaison est envoyée via l’infrarouge du dispositif/CBX (ex. descente de l’écran, allumage du projecteur).',
    startRSTip: 'Lors du démarrage, une commande d’allumage est envoyée via l’interface Serial du dispositif/CBX.',
    CloseDisplayTip: 'Les dispositifs connectés à l’interface DISPLAY s’éteignent automatiquement lors de l’extinction du NDP/NMP. Ce paramètre est géré par le firmware et ne peut pas être modifié par le logiciel.',
    CloseExternalTip: 'Les dispositifs connectés à l’interface EXTERNAL s’éteignent automatiquement lors de l’extinction du NDP/NMP. Ce paramètre est géré par le firmware et ne peut pas être modifié par le logiciel.',
    ClosePowerTip: 'Lors de l’extinction, tous les dispositifs connectés aux interfaces d’alimentation du CBX sont désactivés.',
    CloseAirTip: 'Lors de l’extinction, tous les climatiseurs liés sont éteints via l’infrarouge du dispositif/CBX.',
    CloseIrTip: 'Lors de l’extinction, une commande de liaison est envoyée via l’infrarouge du dispositif/CBX (ex. montée de l’écran, extinction du projecteur).',
    CloseRSTip: 'Lors de l’extinction, une commande d’arrêt est envoyée via l’interface Serial du dispositif/CBX.',
    npsOpenRS232Tip: "Lorsque l'alimentation principale est activée, les deux ports série du NPS recevront les codes de commande de mise sous tension correspondants.",
    "npsRS232Tip": "Lorsque l'alimentation principale est coupée, les deux interfaces Serial de NPS recevront les codes de commande d'arrêt correspondants.",
    "useCardTip": "Après le déverrouillage de la carte, l'alimentation des appareils sera automatiquement activée.",
    "npsCardTip": "Après le déverrouillage de la carte, l'alimentation principale des appareils sera automatiquement activée.",
    "PowerOutageHandling": "Gestion des pannes de courant",
    "PowerOutageHandTip": "Pour continuer l'accès en cas de panne de courant inattendue, choisissez 'Déverrouiller en cas de panne de courant'. Sinon, sélectionnez 'Verrouiller en cas de panne de courant' pour restreindre l'accès.",
    "acSetting": "Paramètre A/C",
    "ChooseType": "Type d'appareil",
    "ChooseBrand": "Sélectionner une marque",
    "ChooseModel": "Sélectionner un modèle",
    "btnConnectingTest": "Test de connexion",
    "LockSetting": "Paramètre de serrure électrique",
    "ElectricLockType": "Type de serrure électrique :",
    "PowerUNLOCK": "Déverrouillage en cas de panne de courant",
    "PowerLOCK": "Verrouillage en cas de panne de courant",
    "none": "Aucun",
    "oddParity": "Parité impair",
    "EvenParity": "Parité pair",
    "LastSetting": "Dernière configuration",
    "ElectricLockClosing": "Fermeture de la serrure électrique :",
    "manualSwitch": "Interrupteur manuel",
    "Auto": "Auto (dans",
    "projectorSetting": "Sélection et liaison de périphériques",
    "baudRate": "Débit en bauds",
    "Parity": "Parité",
    "ON": "Allumer",
    "OFF": "Éteindre",
    "Channel1": "Canal 1",
    "Channel2": "Canal 2",
    "PowerOffDelay": "Délai d'extinction",
    "second": "s",
    "DefaultChannel": "Canal par défaut",
    "HDMIA": "HDMI sortie A:",
    "HDMIB": "HDMI sortie B:",
    "HDMIC": "HDMI sortie C:",
    "btnSaveApply": "Enregistrer et appliquer à...",
    "btnSave": "Enregistrer",
    "btnCustomize": "Personnalisé",
    "ACIsPowerTitle": "Vérifier si le climatiseur est allumé ?",
    "ACIsPowerContent": "Veuillez éteindre le climatiseur avant de tester. Si l'allumage échoue, veuillez vérifier que la marque et le modèle du climatiseur sont corrects.",
    "btnNextModel": "Non, tester le modèle suivant",
    "btnYes": "Oui",
    "errorConnecting": "Échec du test de connexion",
    "hot": "CHAUD",
    "_MAGNETICLOCK": "Verrouillage électronique",
    "_AIR": "Climatiseur",
    "_POWERA": "Display Power",
    "_POWERB": "External Power",
    "_HDMI1": "HDMI in 1",
    "_HDMI2": "HDMI in 2",
    "_HDMI3": "HDMI in 3",
    "_HDMIA": "HDMI out A",
    "_HDMIB": "HDMI out B",
    "_HDMIC": "HDMI out C",
    '_AUDIOA': 'HDMI out A',
    '_AUDIOB': 'Audio IN 1',
    '_AUDIOC': 'Audio IN 2',
    "_USB1": "USB 1",
    "_USB2": "USB 2",
    "_USB3": "USB 3",
    "_USBA": "USB A",
    "_USBB": "USB B",
    "IRControl": "Paramètres de contrôle IR",
    "acControlTitle": "Sélectionner un appareil A/C :",
    "acControlTitleNew": "Appareil A/C",
    "intelligentControlTitle": "Sélectionner un appareil de télécommande :",
    "intelligentControlTitleNew": "Appareil de télécommande",
    "btnACControlCode": "Identifier le nouveau code de contrôle A/C",
    "btnAddRemoteControl": "Nouveau code de télécommande",
    "ACControlCodeTitle": "Identifier le code de contrôle A/C",
    "ACControlCodeseft1": "Identifier le code",
    "ACControlCodeseft2": "Ajouter des informations",
    "btnStartIdentify": "Démarrer",
    "Identifysuccess": "Identification réussie !",
    "BeingIdentify": "Analyse en cours...",
    "acBrand": "Marque de l'A/C",
    "acModel": "Modèle de l'A/C",
    "IdentifyFailureTitle": "Échec de la recherche du code",
    "IdentifyFailureContent": "L'identification a échoué, ce modèle n'est pas actuellement pris en charge. Veuillez essayer la télécommande",
    "btnTryAgain": "Réessayer",
    "btnJump": "Aller à la télécommande",
    "ACrideo": "A/C",
    "ortherRideo": "Autres appareils",
    "btnBack": "Retour",
    "btnSortOut": "Aller à l'édition",
    "remoteControlSeft1": "Sélectionner le type d'appareil",
    "remoteControlSeft2": "Apprendre le code",
    "remoteControlSeft3": "Ajouter des informations",
    "addRemoteControlError": "Désolé, il n'est pas possible d'apprendre plus de codes. Veuillez d'abord modifier les codes de télécommande existants",
    "btnPrevious": "Précédent",
    "btnNextStep": "Suivant",
    "remoteControlErrorTitle": "Échec de l'apprentissage du code",
    "remoteControlErrorContent1": "1. L'émetteur infrarouge n'est pas bloqué",
    "remoteControlErrorContent2": "2. Aucune lumière forte autour du récepteur",
    "remoteControlErrorContent3": "3. L'émetteur infrarouge est installé correctement",
    "remoteControlErrorContent4": "4. La télécommande fonctionne bien",
    "deviceItem1": "A/C",
    "deviceItem2": "Projecteur",
    "deviceItem3": "TV",
    "deviceItem4": "Ventilateur",
    "deviceItem5": "Lumière",
    "deviceItem6": "Autres",
    "deviceItem7": "Panneau interactif",
    "deviceItem8": "Système de capture de conférence",
    "deviceItem9": "Caméra PTZ",
    "RS232protocol": "Protocole Serial :",
    "btnRemoteControl": "Commencer l'apprentissage",
    "BeingIdentify1": "Analyse en cours...",
    "Identifysuccess1": "Succès",
    "controllerType1": "A/C",
    "controllerType2": "Serial",
    "controllerType3": "TV",
    "controllerType4": "Ventilateur",
    "controllerType5": "Lumière",
    "controllerType9": "Autres",
    "rqRemoteControlCode": "Veuillez entrer le nom du code de télécommande",
    "rqBrand": "Veuillez entrer la marque du A/C",
    "rqModel": "Veuillez entrer le modèle du A/C",
    "error2016": "Le nom de la télécommande est dupliqué, veuillez en entrer un autre",
    "RS232Setting": "Paramètre de code série",
    "IR232Setting": "Paramètre IR",
    "SystemError": "Erreur système. Veuillez réessayer",
    "conditionerCodeContent": "Impossible de trouver le code du climatiseur, veuillez réessayer",
    "remoteControlCodeContent": "Impossible de trouver le code de la télécommande, veuillez réessayer",
    "btnRetry": "Réessayer",
    "Bindusers": "Lier l'utilisateur",
    "tablebinduser": "Lier les utilisateurs",
    "Refresh": "Actualiser",
    "Binduserlable": "Lier les utilisateurs qui peuvent contrôler l'appareil maintenant ?",
    "SaveApplySuccessfully": "Sauvegarder et appliquer avec succès",
    "DeviceType": "Type :",
    "tableDeviceType": "Type",
    "empty": "C'est vide.",
    "sendCommand": "Envoyer plus tard",
    "enable": "Activer",
    "disable": "Désactiver",
    "SYNCremoteControl": "SYNC avec télécommande",
    "analysisfailed": "L'analyse a échoué, veuillez réessayer !",

    "CBX": {
      "powerSupplyON": "Allumer",
      "powerSupplyOFF": "Éteindre",
      "powerVcrON": "Commencer l'enregistrement",
      "powerVcrOFF": "Arrêter l'enregistrement",
      "lockScreenON": "Verrouiller",
      "lockScreenOFF": "Déverrouiller",
      "childLockON": "Verrouillage enfant activé",
      "childLockOFF": "Verrouillage enfant désactivé",
      "energySavingON": "Économie d'énergie activée",
      "energySaving": "Économie d'énergie",
      "energySavingOFF": "Économie d'énergie désactivée",
      "signalSourceSwitchingON": "OPS",
      "signalSourceSwitchingOFF": "Android",
      "volumeAdjustment": "Haut-parleur",
      "brightAdjustment": "Luminosité",
      "other": "Autres fonctionnalités...",
      "volumeExample": "Fonctionnalité Serial complète requise pour une compatibilité totale avec le système d'enregistrement.",
      "functionCode": "Fonction :",
      "Name": "Nom :",
      "controlCode": "Code de contrôle :",
      "brand": "Marque :",
      "model": "Modèle :",
      "errorBrandName": "La marque ne peut pas être vide !",
      "errorModelName": "Le modèle ne peut pas être vide !"
    }

  },
  "roleMge": {
    "role1": "Utilisateur général",
    "role101": "Administrateur d'agent",
    "role102": "Administrateur",
    "role4": "Rôle personnalisé",
    "roleNew": "Nouveau rôle",
    "btnAddRole": "Ajouter un rôle",
    "chooseUser": "Choisir un utilisateur",
    "titleLevel": "Niveau de propriété de diffusion :",
    "titleSettings": "Paramètres de permission :",
    "btnSave": "Sauvegarder",
    "btnDelete": "Supprimer",
    "cancel": "Annuler",
    "confirm": "Confirmer",
    "save": "Sauvegarder",
    "addSuccess": "Ajout réussi !",
    "addError": "Échec de l'ajout !",
    "editSuccess": "Modification réussie !",
    "editError": "Échec de la modification !",
    "delSuccess": "Suppression réussie !",
    "delError": "Échec de la suppression !",
    "V3_0_OrganizationManage": "Gestion des groupes",
    "V3_0_UserManage": "Gestion des utilisateurs",
    "V3_0_DeviceManage": "Gestion des appareils",
    "V3_0_CloudSpaceManage": "Gestion de l'espace cloud",
    "V3_0_OrganizationManage_View": "Voir",
    "V3_0_OrganizationManage_Edit": "Modifier",
    "V3_0_UserManage_View": "Voir",
    "V3_0_UserManage_Edit": "Modifier",
    "V3_0_DeviceManage_AddDevice": "Ajouter un appareil",
    "V3_0_DeviceManage_Operating": "Opérer",
    "V3_0_DeviceManage_Delete": "Supprimer",
    "V3_0_DeviceManage_Edit": "Modifier",
    "V3_0_CloudSpaceManage_PersonalManage": "Gestion du cloud personnel",
    "V3_0_CloudSpaceManage_PublicManage": "Gestion du cloud public",
    "V3_0_CloudSpaceManage_SpaceManage": "Attribution d'espace",
    "V3_0_CloudSpaceManage_PersonalManage_Operating": "Exploitation",
    "V3_0_CloudSpaceManage_PersonalManage_View": "Voir",
    "V3_0_CloudSpaceManage_PublicManage_View": "Voir",
    "V3_0_CloudSpaceManage_PublicManage_Upload": "Télécharger",
    "V3_0_CloudSpaceManage_PublicManage_Download": "Télécharger",
    "V3_0_CloudSpaceManage_PublicManage_DeleteFile": "Supprimer le fichier",
    "V3_0_CloudSpaceManage_PublicManage_EditFolder": "Modifier le dossier",
    "delTitle": "Supprimer ?",
    "delTitleContent": "Les contenus sélectionnés seront supprimés de la base de données. Cette opération est irréversible. Êtes-vous sûr de vouloir continuer ?",
    "delCancelButton": "Annuler",
    "delConfirmButton": "Confirmer",
    "btnAdd": "Ajouter un rôle",
    "RoleName": "Nom du rôle :",
    "ManageRange": "Plage de gestion :",
    "ChooseUser": "Choisir un utilisateur :",
    "PermissionSettings": "Paramètres des autorisations :",
    "BroadcastingPropertyLevel": "Niveau des propriétés de diffusion",
    "ChooseGroups": "Choisir les groupes",
    "ChooseTheUser": "Choisir l'utilisateur",
    "deleleTitle": "Le nouveau rôle n'a pas été enregistré. Si vous partez, le rôle sera supprimé. Êtes-vous sûr de vouloir partir ?",
    "Error1601": "Impossible d'utiliser l'administrateur",
    "Error1602": "Échec de l'obtention du rôle d'autorisation",
    "Error1603": "Seuls les administrateurs ont accès à ces fonctionnalités",
    "Error1604": "Le nom du rôle ne peut pas être vide",
    "Error1605": "Le groupe ne peut pas être vide",
    "Error1606": "Ce rôle existe déjà",
    "Error1607": "Rôle défini par le système, modification non autorisée",
    "Error1608": "Échec de la configuration du rôle",
    "Error1609": "Rôle utilisateur commun du système, modification non autorisée",
    "Error1610": "Veuillez utiliser le rôle d'administrateur terminal pour effectuer les opérations associées",
    "Error1611": "Ne dispose pas des autorisations de rôle associées"
  },
  "projectorDevicesMge": {
    "tipOne": "1. Remplissez le nom de la fonction et le code de contrôle. Les exemples de code utilisent le format HEX.",
    "tipTwo": "2. Cette interface sert uniquement à configurer les commandes série d'allumage/extinction. Veuillez accéder à 'Gestion des périphériques / Périphériques / Opérations / Paramètres d'alimentation' pour activer la fonction.",
    "tipFunctionOne": "1. Sélectionnez les fonctions courantes dans la liste déroulante. Les icônes correspondantes s'afficheront sur l'interface de contrôle série du panneau intelligent.",
    "tipFunctionTwo": "2. Les commandes 'POWER ON' et 'POWER OFF' sont utilisées pour la liaison série d'allumage/extinction de l'appareil. Cette page configure uniquement les codes de contrôle. Veuillez accéder à 'Gestion des périphériques / Périphériques / Opérations / Paramètres d'alimentation' pour activer la fonction de liaison.",
    "ListRS232functions": "Liste des fonctions de contrôle série",
    "Customizefunctionlist": "Personnaliser la liste des fonctions",
    "btnAddProjectorCode": "Ajouter le code série",
    "btnDel": "Supprimer",
    "inputSeach": "Rechercher",
    "btnEdit": "Modifier",
    "cancel": "Nettoyer",
    "confirm": "Confirmer",
    "tableName": "Nom du code",
    "tablersType": "Type d'appareil :",
    "tablersTypeTable": "Type d'appareil",
    "tableModel": "Modèle",
    "tableBrand": "Marque",
    "tableActions": "Actions",
    "dialogAddTitle": "Ajouter un code Serial",
    "dialogEditTitle": "Modifier un code Serial",
    "brand": "Nom de la marque :",
    "model": "Modèle :",
    "baudRate": "Débit en bauds :",
    "parity": "Parité :",
    "powerOn": "ACTIVER",
    "powerOff": "DÉSACTIVER",
    "pgrInput1": "Canal 1",
    "pgbInput2": "Canal 2",
    "delTitle": "Supprimer ?",
    "delTitleContent": "Les contenus sélectionnés seront supprimés de la base de données. Cette opération est irréversible. Êtes-vous sûr de vouloir continuer ?",
    "delCancelButton": "Annuler",
    "delConfirmButton": "Confirmer",
    "content": "Rechercher",
    "operate": "Actions",
    "tableDel": "Supprimer",
    "tableEdit": "Modifier",
    "addSuccess": "Ajout réussi !",
    "addError": "Échec de l'ajout !",
    "editSuccess": "Modification réussie !",
    "editError": "Échec de la modification !",
    "delSuccess": "Suppression réussie !",
    "delError": "Échec de la suppression !",
    "selectTitle": "Veuillez sélectionner un Serial !",
    "selectCode": "Sélectionner un Serial",
    "none": "Aucune",
    "oddParity": "Parité impaire",
    "EvenParity": "Parité paire"
  },
  "authorityMge": {
    "V3_0_OrganizationManage": "Gestion des groupes",
    "V3_0_UserManage": "Gestion des utilisateurs",
    "V3_0_DeviceManage": "Gestion des appareils",
    "V3_0_CloudSpaceManage": "Gestion de l'espace cloud",
    "V3_0_OrganizationManage_View": "Voir",
    "V3_0_OrganizationManage_Edit": "Modifier",
    "V3_0_UserManage_View": "Voir",
    "V3_0_UserManage_Edit": "Modifier",
    "V3_0_DeviceManage_AddDevice": "Ajouter un appareil",
    "V3_0_DeviceManage_Operating": "Opérer",
    "V3_0_DeviceManage_Delete": "Supprimer",
    "V3_0_DeviceManage_Edit": "Modifier",
    "V3_0_DeviceManage_RepairLog": "Journal de réparation",
    "V3_0_CloudSpaceManage_PersonalManage": "Gestion du cloud personnel",
    "V3_0_CloudSpaceManage_PublicManage": "Gestion du cloud public",
    "V3_0_CloudSpaceManage_SpaceManage": "Gestion de l'espace cloud",
    "V3_0_CloudSpaceManage_PersonalManage_Operating": "Opérer",
    "V3_0_CloudSpaceManage_PersonalManage_View": "Voir",
    "V3_0_CloudSpaceManage_PublicManage_View": "Voir",
    "V3_0_CloudSpaceManage_PublicManage_Upload": "Télécharger",
    "V3_0_CloudSpaceManage_PublicManage_Download": "Télécharger",
    "V3_0_CloudSpaceManage_PublicManage_DeleteFile": "Supprimer",
    "V3_0_CloudSpaceManage_PublicManage_EditFolder": "Modifier",
    "delTitle": "Supprimer ?",
    "delTitleContent": "Les éléments sélectionnés seront supprimés de la base de données. Cette opération est irréversible. Êtes-vous sûr de vouloir continuer ?",
    "delCancelButton": "Annuler",
    "delConfirmButton": "Confirmer",
    "content": "Rechercher",
    "operate": "Action",
    "tableDel": "Supprimer",
    "tableEdit": "Modifier",
    "addSuccess": "Ajout réussi !",
    "addError": "Échec de l'ajout !",
    "editSuccess": "Modification réussie !",
    "editError": "Échec de la modification !",
    "delSuccess": "Suppression réussie !",
    "delError": "Échec de la suppression !",
    "selectTitle": "Veuillez sélectionner Serial !"
  },
  "workstationMge": {
    "priorChoice": "Préférence de diffusion :",
    "SpeedPriority": "Priorité à la vitesse",
    "SyncPriority": "Priorité à la synchronisation des images",
    "SpeedPriorityTip": "Après l'envoi des instructions de diffusion AV, les terminaux Q-NEX peuvent effectuer la tâche de lecture dans un délai de tampon plus court, environ 3 à 5 secondes. La priorité à la vitesse est fortement recommandée lorsque le serveur multimédia fonctionne en LAN.",
    "SyncPriorityTip": "Après l'envoi des instructions de diffusion AV, les terminaux Q-NEX peuvent effectuer la tâche de lecture de manière synchrone avec un délai de tampon d'environ 8 à 12 secondes.",
    "btnAddMedia": "Ajouter un serveur multimédia",
    "btnBack": "Retour",
    "tableMediaLibId": "ID du serveur multimédia",
    "tableMediaLibName": "Nom du serveur multimédia",
    "tableState": "État du réseau",
    "tableBindingUsers": "Utilisateurs liés",
    "tableLiveAddress": "Adresse de diffusion",
    "tableAddress": "Adresse de streaming",
    "tableOperate": "Actions",
    "tableDel": "Supprimer",
    "tableEdit": "Modifier",
    "titleMediaStation": "Adresse de diffusion",
    "titleLiveStation": "Adresse de streaming :",
    "radioPublic": "Publique",
    "radioPrivate": "Privée",
    "btnSave": "Enregistrer",
    "titleUsers": "Utilisateurs",
    "titleCanBe": "Peut être lié",
    "titleHaveBeen": "Est lié",
    "titleMore": "Besoin d'ajouter plus ?",
    "btnAdd": "Ajouter",
    "content": "Rechercher",
    "tableName": "Nom",
    "tableUserName": "Nom d'utilisateur",
    "operate": "Actions",
    "affiliatedOrganization": "Groupes",
    "dialogTitle": "Ajouter un nouveau serveur multimédia",
    "dialogTitleEdit": "Modifier le nouveau serveur multimédia",
    "dialogItemName": "Nom :",
    "dialogItemId": "ID :",
    "dialogItemIp": "Adresse de diffusion :",
    "titleSelectUsers": "Sélectionner les utilisateurs",
    "selectMedia": "Veuillez choisir un média",
    "delTitle": "Êtes-vous sûr de vouloir supprimer ?",
    "delMediaLibTitle": "Confirmation de suppression ?",
    "delTitleContent": "Les éléments sélectionnés seront supprimés de la base de données. Cette opération est irréversible. Êtes-vous sûr de vouloir continuer ?",
    "delTitleMediaLibContent": "L'action de suppression entraînera la suppression des données pertinentes et ne peut pas être annulée.",
    "delCancelButton": "Annuler",
    "delConfirmButton": "Confirmer",
    "selectDevices": "Veuillez sélectionner des dispositifs",
    "selectUser": "Veuillez sélectionner des utilisateurs",
    "addUser": "Ajouter un utilisateur",
    "editUser": "Modifier un utilisateur",
    "addSuccess": "Ajout réussi !",
    "addError": "Échec de l'ajout !",
    "editSuccess": "Modification réussie !",
    "editError": "Échec de la modification !",
    "delSuccess": "Suppression réussie !",
    "delError": "Échec de la suppression !",
    "cancel": "Annuler",
    "confirm": "Confirmer",
    "save": "Enregistrer",
    "error2500": "Le nombre maximal de dispositifs pouvant être connectés à la station de travail actuelle est dépassé.",
    "DeviceName": "Nom du dispositif",
    "AssociatedUserManagement": "Gestion des utilisateurs associés",
    "btnDel": "Supprimer",
    "errorMsgId": "Impossible de trouver cet ID",
    "LiveStreaming": "Adresse de streaming :",
    "NoFoundMediaId": "Impossible d'obtenir l'ID du serveur multimédia",
    "AlreadyConnectedOrg": "Le serveur multimédia est déjà associé à une autre organisation",
    "AlreadyBoundMedia": "Cette organisation a déjà lié un serveur multimédia, et ne peut en lier un autre",
    "DeleteSecondaryConfirmation": "Les données ne peuvent pas être récupérées après la suppression du serveur multimédia, veuillez confirmer à nouveau."
  },
  "cloudDiskMge": {
    "totalStorage": "STOCKAGE TOTAL",
    "GetMore": "Obtenez plus",
    "StorageSpace": "Espace de stockage",
    "Adjustment": "Ajustement",
    "moreSpace": "Obtenez plus d'espace de stockage",
    "PublicStorage": "Stockage public",
    "PublicStorageUsed": "Stockage public utilisé",
    "PublicStorageLasted": "Stockage public restant",
    "IndividualStorageUsed": "Stockage personnel utilisé",
    "IndividualStorageLasted": "Stockage personnel restant",
    "storageSpace": "Ajustement de l'espace de stockage",
    "tableUserName": "Nom d'utilisateur",
    "tableUsedSpace": "Espace utilisé",
    "tableAvailableSpace": "Espace disponible",
    "tableActiveTime": "Dernière heure active",
    "tableOperate": "Actions",
    "cleanup": "Note pour nettoyage",
    "IndividualStorageSpaceAdjustment": "Ajustement de l'espace de stockage personnel",
    "titleTotal": "Total",
    "PublicDisk": "Cloud public",
    "IndividualDisk": "Cloud personnel",
    "PerUser": "Par utilisateur",
    "UsersInTotal": "Utilisateurs totaux",
    "cancel": "Annuler",
    "confirm": "Confirmer",
    "save": "Sauvegarder",
    "addSuccess": "Ajout réussi !",
    "addError": "Échec de l'ajout !",
    "editSuccess": "Modification réussie !",
    "editError": "Échec de la modification !",
    "delSuccess": "Suppression réussie !",
    "delError": "Échec de la suppression !",
    "error3000": "L'opération a échoué car la taille totale du stockage a été dépassée.",
    "error3003": "Opération échouée, veuillez vérifier si un serveur multimédia a été configuré.",
    "IndividualStorage": "Stockage personnel",
    "NoteToCleanup": "Note pour nettoyage",
    "updatePersonalSuccess": "Votre espace de stockage cloud sera plein, veuillez nettoyer à temps",
    "updatePersonalSuccess1": "Modifié et enregistré avec succès",
    "storageUsage": "Utilisation du stockage personnel",
    "bindIndividualstorage": "Utilisateurs autorisés à avoir un stockage cloud personnel",
    "UserIndividualstorage": "Utilisateurs ayant déjà configuré un stockage cloud personnel",
    "Notificationsuccessfully": "Notification envoyée avec succès",
    "Notificationfailed": "Échec de l'envoi de la notification",
    "tableName": "Nom",
    "userID": "ID utilisateur"
  },
  "dashboard": {
    "exportPdf": "Exporter PDF",
    "or": "-",
    "warrantyCompletionRate": "Taux de réparation",
    "frequencyOfEachModule": "Le pourcentage de réparation de chaque module fonctionnel",
    "repairHandling": "État du traitement de la réparation",
    "sourceSwitchInput": "Interrupteur d'entrée",
    "micVol": "Volume du micro",
    "volumeSpeaker": "Volume du haut-parleur",
    "airAonditioner": "Climatisation",
    "Curtain": "Écran du projecteur",
    "remoteControlIntelligent": "Télécommande",
    "RS232Control": "Contrôle Serial",
    "lockElectronic": "Verrous électroniques",
    "Repairreportcompleted": "Réparé",
    "Totalnumberofrepairsreported": "Réparations totales",
    "Warrantycompletionrate": "Taux de réalisation de la réparation",
    "startDate": "Date de début",
    "endDate": "Date de fin",
    "year": "Année",
    "month": "Mois",
    "dayTian": "Jour",
    "placeholderDate": "Sélectionner la date",
    "placeholderDateTime": "Sélectionner l'heure",
    "devicesNub": "Appareils",
    "userNub": "Utilisateurs",
    "powerNub": "Puissance (KW/H)",
    "storageUsed": "Stockage utilisé (%)",
    "userLoginDevice": "Période active de connexion des utilisateurs",
    "devicePowerConsumption": "Consommation d'électricité quotidienne de tous les appareils",
    "externalDeviceUsageTime": "Utilisation des appareils externes",
    "equipmentRunningTime": "Utilisation des appareils terminaux",
    "cloudStorageSpace": "Utilisation du stockage",
    "powerConsumptionPort": "Consommation d'énergie de chaque port d'alimentation",
    "mostPopularFile": "Fichier le plus populaire",
    "commonFunctions": "Fonctions courantes",
    "commonlyUsed": "Méthode de diffusion la plus courante",
    "fileName": "Nom du fichier",
    "usageCount": "Nombre d'utilisations",
    "electricityConsumption": "Consommation d'électricité",
    "publicStorageUsed": "Stockage public utilisé",
    "publicStorageLasted": "Stockage public restant",
    "individualStorageUsed": "Stockage individuel utilisé",
    "individualStorageLasted": "Stockage individuel restant",
    "notification": "Notification",
    "audioBroadcast": "Diffusion audio",
    "videoBroadcast": "Diffusion vidéo",
    "ac": "Climatisation",
    "hDMISwitch": "Commutateur HDMI",
    "powerControl": "Contrôle de l'alimentation",
    "powercontrol": "Contrôle de l'alimentation",
    "Lock": "Verrouiller",
    "volumeAdjust": "Réglage du volume",
    "projectionScreen": "Écran de projection",
    "today": "Aujourd'hui",
    "yesterday": "Hier",
    "thisWeek": "Cette semaine",
    "lastWeek": "La semaine dernière",
    "lastMonth": "Le mois dernier",
    "thisMonth": "Ce mois-ci",
    "times": "Fois",
    "usage": "Nombre d'utilisations",
    "eachrTitle": "Minutes",
    "total": "Total",
    "NMPSystemissue": "Problème du système NMP",
    "displayPower": "Problème du périphérique externe NMP",
    "externalPower": "Problème du système MBX",
    "screen": "Problème du périphérique externe MBX",
    "TotalRepairs": "Réparations totales",
    "Repaired": "Réparé",
    "Unrepaired": "Non réparé",
    "day": "JOUR",
    "Minutes": "Minutes",
    "powerConsumption": "Minutes",
    "Date": "Date",
    "kw": "KW",
    "month1": "LUN",
    "month2": "MAR",
    "month3": "MER",
    "month4": "JEU",
    "month5": "VEN",
    "month6": "SAM",
    "month7": "DIM",
    "enmonth1": "Janv",
    "enmonth2": "Févr",
    "enmonth3": "Mars",
    "enmonth4": "Avr",
    "enmonth5": "Mai",
    "enmonth6": "Juin",
    "enmonth7": "Juil",
    "enmonth8": "Août",
    "enmonth9": "Sept",
    "enmonth10": "Oct",
    "enmonth11": "Nov",
    "enmonth12": "Déc",
    "noData": "Pas de données"
  },
  "input": {
    "fivedigits": "Veuillez entrer un entier positif de 5 chiffres",
    "titlUserNameField": "Ce nom d'utilisateur doit être rempli",
    "thisField": "Ce champ doit être rempli",
    "ChooseGroup": "Choisir un groupe",
    "placeholder": "Sélectionner",
    "placeholder_type": "Veuillez sélectionner les types de contrôle des appareils",
    "titlRealNameField": "Le mot de passe doit être rempli",
    "thisPasswordField": "Le mot de passe doit être rempli",
    "titlPassWordNub": "Moins de 15 lettres",
    "Post": "Numéros uniquement",
    "passwordNoChinese": "Cette zone de saisie ne peut pas être remplie de caractères chinois"
  },
  "transfer": {
    "all": "Tout",
    "Choose": "Choisir",
    "Selected": "Sélectionné",
    "Subordinate": "Subordonné"
  },
  "setting": {
    limitPngGif: 'Seuls les formats PNG / GIF sont pris en charge',
    limit3M: 'La taille de l’image ne doit pas dépasser 3 Mo',
    setting_door_Wallpaper_text: 'Taille d’image recommandée : 1280x800, format PNG ou GIF',

    "reduction": "Restaurer",
    "limitJpg": "L'image de profil téléchargée ne peut être qu'au format PNG !",
    "limit2M": "La taille de l'image de profil téléchargée ne doit pas dépasser 2 Mo !",
    "choseFile": "Sélectionner le fichier",
    "textOne": "1. Image LOGO recommandée : taille 117*40, au format PNG",
    "textTwo": "2. Après le téléchargement, veuillez vous rendre sur le panneau tactile, assurez-vous que le panneau tactile est connecté à Internet, puis cliquez sur le logo d'origine pour actualiser.",
    "customizeLogo": "Paramètre du logo du panneau tactile",
    "addSuccess": "Paramètre réussi !",
    "settingIp": "Paramètre de l'adresse IP de stockage de fichiers",
    "ServerIP": "Adresse IP du serveur :",
    "ServerPort": "Port du serveur :",
    "btnSave": "Enregistrer",
    "TimeZoneSetting": "Paramètre de fuseau horaire",
    "CurrentTime": "Heure actuelle :",
    "CurrentTimeZone": "Fuseau horaire actuel :",
    "httpsSetting": "Stockage de fichiers :",
    "utcName": "Temps moyen de Greenwich UTC/GMT",
    "utc0": "Temps moyen de Greenwich, Royaume-Uni, Lisbonne, Torshavn, Londres, Dublin, Édimbourg",
    "utc0_5": "",
    "utc1": "Europe centrale, Afrique de l'Ouest, Afrique centrale de l'Ouest, Allemagne, Irlande, France, Amsterdam, Italie, Berlin, Rome, Espagne, Prague, Belgrade, Bruxelles, Paris, Madrid, Tunisie, Gabon, Maroc",
    "utc1_5": "",
    "utc2": "Europe de l'Est, Afrique centrale, Turquie, Israël, Afrique du Sud, Istanbul, Le Caire, Athènes, Damas",
    "utc2_5": "",
    "utc3": "Afrique de l'Est, Russie, Bagdad, Koweït, Moscou, Saint-Pétersbourg",
    "utc3_5": "Iran",
    "utc4": "Abou Dhabi, Tbilissi, Dubaï, Maurice, Port Louis",
    "utc4_5": "Afghanistan",
    "utc5": "Pakistan, Turkménistan, Maldives, Ouzbékistan, Arménie, Tadjikistan Inde, Mumbai, New Delhi, Bangalore, Calcutta",
    "utc5_5": "Inde, Sri Lanka",
    "utc6": "Novossibirsk, Kirghizistan, Bangladesh, Bhoutan",
    "utc6_5": "Îles Cocos Australie, Vietnam",
    "utc7": "Thaïlande, Bangkok, Hanoi, Jakarta",
    "utc7_5": "",
    "utc8": "Chine, Malaisie, Philippines, Singapour, Taïwan Chine, Macao Chine, Hong Kong Chine",
    "utc8_5": "",
    "utc9": "Japon, Corée du Sud, Tokyo, Séoul, Sapporo, Osaka, Timor oriental",
    "utc9_5": "Heure normale centrale australienne",
    "utc10": "Australie, Vladivostok, Guam, Canberra, Melbourne, Sydney, Papouasie-Nouvelle-Guinée",
    "utc10_5": "Île Lord Howe de la Nouvelle-Galles du Sud, Australie",
    "utc11": "Îles Salomon, île Sakhaline",
    "utc11_5": "Île Norfolk, Australie",
    "utc12": "Nouvelle-Zélande, Auckland, Wellington, Fidji, Nouvelle-Zélande, Nauru",
    "utc12_5": "",
    "utc13": "Cap-Vert, Açores",
    "utc13_5": "",
    "utc14": "Géorgie du Sud, Fernando de Noronha",
    "utc14_5": "",
    "utc15": "Brésil, Santiago, Salvador, Brasilia, Uruguay, Argentine, Suriname",
    "utc15_5": "Heure standard de Terre-Neuve",
    "utc16": "Venezuela, Bolivie, Paraguay, Chili",
    "utc16_5": "Venezuela",
    "utc17": "Heure de l'Est (États-Unis et Canada), Colombie, Toronto, Équateur, Pérou, Cuba, New York, Hamilton, San Diego",
    "utc17_5": "",
    "utc18": "Heure centrale des États-Unis et du Canada, Mexico, Monterrey, Chicago, Houston, La Nouvelle-Orléans, Memphis",
    "utc18_5": "",
    "utc19": "Heure des montagnes, Arizona, Mazatlán, Phoenix, Salt Lake City, Denver, Edmonton",
    "utc19_5": "",
    "utc20": "Heure du Pacifique, Los Angeles, San Francisco, Vancouver, Seattle, Las Vegas",
    "utc20_5": "",
    "utc21": "Alaska",
    "utc21_5": "Polynésie française, îles Marquises",
    "utc22": "Hawaï",
    "utc22_5": "",
    "utc23": "Samoa, Niue",
    "utc23_5": "",
    "utc24": ""
  },
  "repairLog": {
    "DeviceName": "Nom de l'appareil :",
    "Time": "Temps :",
    "startDate": "Date de début",
    "endedDate": "Date de fin",
    "or": "-",
    "Problem": "Problème :",
    "btnSearch": "Rechercher",
    "tableNO": "Non",
    "tableDeviceName": "Nom de l'appareil",
    "tableGroup": "Groupe",
    "tableStatus": "Statut",
    "tableDeliveredTime": "Temps de livraison",
    "tableSubmitter": "Soumissionnaire",
    "tableUpdatingTime": "Temps de mise à jour",
    "tableProblem": "Problème",
    "tableAdmin": "IT-Admin",
    "tableAdminReply": "Réponse de l'Admin",
    "tableAttachment": "Pièce jointe",
    "state0": "Livré",
    "state1": "En cours",
    "state2": "Terminé",
    "Problem100": "TOUT",
    "Problem0": "Problème système",
    "Problem1": "Problème périphérique externe",
    "ProblemType": "",
    "ProblemType0": "Contrôle de l'alimentation",
    "ProblemType1": "Commutateur HDMI",
    "ProblemType2": "Micro",
    "ProblemType3": "Haut-parleur",
    "ProblemType4": "Climatisation",
    "ProblemType5": "Écran de projection",
    "ProblemType6": "Verrou électronique",
    "ProblemType7": "Diffusion audio/vidéo",
    "ProblemType8": "Contrôle IR",
    "ProblemType9": "Contrôle Serial",
    "dialogDeviceName": "Nom de l'appareil",
    "dialogDeviceID": "ID de l'appareil",
    "dialogGroup": "Groupe",
    "dialogSubmitter": "Soumissionnaire",
    "dialogStatus": "Choisir un statut",
    "dialogProblem": "Problème",
    "dialogNotes": "Notes",
    "dialogRepairation": "Réparation",
    "dialogInProcess": "En cours",
    "dialogCompleted": "Terminé",
    "editSuccess": "Édition réussie !",
    "editError": "Échec de l'édition !",
    "problemRequired": "Veuillez sélectionner un type de problème",
    "detailRequired": "Veuillez décrire le problème en détail",
    "statusRequired": "Veuillez choisir le statut du journal",
    "btnCancel": "Annuler",
    "DeliveredTime": "Temps de livraison",
    "UpdatingTime": "Temps de mise à jour",
    "ITAdmin": "IT-Admin",
    "AdminReply": "Réponse de l'Admin",
    "Note": "Note",
    "Detail": "Détail",
    "controlPanel": "Panneau de contrôle",
    "DeviceType": "Type",
    "dialogDeliveredTime": "Temps de livraison",
    "Submitter": "Soumissionnaire"
  },
  "remoteControl": {
    "QuickActionName": "Nom",
    "DeviceType": "Type",
    "Description": "Description",
    "tableDescription": "Description",
    "editRemoteControl": "Modifier le code de la télécommande",
    "QuickActionNameInput": "Nom",
    "DescriptionInput": "Description",
    "save": "Enregistrer",
    "Brand": "Marque",
    "Model": "Modèle",
    "EditACControlCode": "Modifier le code de contrôle de la climatisation",
    "acBrand": "Marque de la climatisation",
    "acModel": "Modèle de la climatisation"
  },
  "card": {
    "btnAddCard": "Ajouter une carte",
    "btnBatchAddCard": "Ajouter des cartes par lot",
    "tableCard": "Numéro de carte",
    "tableState": "Statut",
    "tableUser": "Utilisateur lié",
    "tableID": "Nom d'utilisateur",
    "tableType": "Type de carte",
    "tableFfective": "Date d'expiration",
    "dialogCard": "Numéro de carte :",
    "dialogState": "Statut :",
    "dialogUser": "Utilisateur lié :",
    "dialogID": "Nom d'utilisateur :",
    "dialogType": "Type de carte :",
    "dialogFfective": "Date d'expiration :",
    "dialogRemarks": "Remarques :",
    "dialogAddTitle": "Ajouter une carte",
    "dialogEidtTitle": "Modifier la carte",
    "code2201": "Le format de la période d'expiration de la carte est incorrect",
    "code2202": "Cette carte est déjà liée",
    "code2203": "Cet utilisateur est déjà lié",
    "code2204": "Cette carte n'est pas liée",
    "mastCard": "Carte principale",
    "regularCard": "Carte générale",
    "permanent": "Permanente",
    "coxPermanent": "Permanente",
    "coxTime": "Période déterminée",
    "tableDeviceName": "Nom de l'appareil",
    "tableDeviceID": "ID de l'appareil",
    "tableOperating": "Opération",
    "tableOperatingTime": "Heure d'exploitation",
    "tableCardID": "Numéro de carte",
    "tableCardType": "Type de carte",
    "tabluserName": "Nom d'utilisateur",
    "tabluserId": "ID utilisateur",
    "unlockPanel": "Déverrouiller le panneau",
    "unlock": "Déverrouiller la porte",
    "conAll": "Tout",
    "btnEnable": "Activer",
    "btnDisable": "Désactiver",
    "enableSuccess": "Activation réussie",
    "stopSuccess": "Désactivation réussie",
    "enableError": "Échec de l'activation",
    "stopError": "Échec de la désactivation",
    "batchCard": "Numéro de carte par lot :",
    "titlCardField": "Le numéro de carte ne peut pas être vide",
    "titlCardFieldFormat": "Seulement des lettres et des chiffres",
    "dialogBachAddTitle": "Ajouter des cartes par lot",
    "pleaseTryAgain1": "Numéro de carte incorrect (NO. :",
    "pleaseTryAgain2": "), veuillez réessayer"
  },
  privacy: {
    PrivacyPolicy: 'Microsoft Organization Binding Privacy Agreement',
    Byusing: 'Dear User,',
    whatinformation: 'Before authorizing Q-NEX to access Microsoft data, please read this agreement carefully. This document is a supplement to the Q-NEX Privacy Policy, and it specifically explains the permissions required for synchronization, the purposes of data usage, and our protection measures. By checking “Agree,” you confirm that you have read and accepted all terms of this agreement.',
    EffectiveDate: 'Effective Date: August 4, 2025',
    title1: 'Required Permissions & Collected Data',
    title1Respects1: 'To enable synchronization between Q-NEX Room Scheduler and Microsoft Calendar, Q-NEX requires the following Microsoft permissions:',
    title1Respects2: 'Delegated Permissions',
    Respects2formation: 'These permissions allow Q-NEX to access your Microsoft account data after login and consent:',
    Respects2formation2: 'Calendars.ReadWrite',
    Respects2formation3: 'Permission Name: Full access to user calendars',
    Respects2formation4: 'Description: Allows the app to create, read, update, and delete events in user calendars.',
    Respects2formation5: 'Purpose: Synchronize personal calendar meetings with the Q-NEX system.',
    Respects2formation6: 'offline_access',
    Respects2formation7: 'Permission Name: Maintain access to data you’ve granted',
    Respects2formation8: 'Description: Allows the app to access authorized data even when you’re not actively using it.',
    Respects2formation9: 'Purpose: Ensures meeting information remains synced even when users are offline.',
    Respects2formation10: 'Openid',
    Respects2formation11: 'Permission Name: Sign in as you',
    Respects2formation12: 'Description: Enables login via work/school accounts and allows the app to read basic profile details.',
    Respects2formation13: 'Purpose: Authenticates user identity for security and associates profiles with meeting data.',
    Respects2formation14: 'Place.Read.All',
    Respects2formation15: 'Permission Name: Read all company places',
    Respects2formation16: 'Description: Allows the app to read company locations (meeting rooms and room lists) on your behalf.',
    Respects2formation17: 'Purpose: Retrieves company room resource lists and syncs meeting room booking statuses.',

    tp1: 'Application Permissions (Requires Admin Consent)',
    tp2: 'These permissions enable Q-NEX to sync data automatically without manual reauthorization:',
    tp3: 'Calendars.ReadWrite',
    tp4: 'Permission Name: Read and write calendars in all mailboxes',
    tp5: 'Description: Allows the app to create, read, update, and delete calendar events without user sign-in.',
    tp6: 'Purpose: Syncs schedules from all company meeting room resource mailboxes.',
    tp7: 'Directory.Read.All',
    tp8: 'Permission Name: Read directory data',
    tp9: 'Description: Allows the app to read organizational directory data (users, groups, apps) without user sign-in.',
    tp10: 'Purpose: Validates meeting room resource mailboxes and retrieves organizational structure.',
    tp11: 'User.Read.All',
    tp12: 'Permission Name: Read all users’ full profiles',
    tp13: 'Description: Allows the app to read user profiles without user sign-in.',
    tp14: 'Purpose: Identifies meeting participants.',
    tp15: 'Place.Read.All',
    tp16: 'Permission Name: Read all company places',
    tp17: 'Description: Allows the app to read company locations (meeting rooms and room lists) for calendar events and other apps without user sign-in.',
    tp18: 'Purpose: Retrieves full meeting room resource lists and syncs availability statuses.',

    title2: 'Purpose of Data Usage',
    title2Respects1: 'Sync Microsoft Calendar meetings to Q-NEX for real-time display on the Room Scheduler.',
    title2Respects2: 'Automatically update room availability to prevent scheduling conflicts.',
    title2Respects3: 'Provide a unified meeting management experience.',

    title3: 'Data Storage & Protection',
    title3Respects1: 'All synced data is encrypted and stored on Q-NEX servers, used solely for this functionality.',
    title3Respects2: 'Q-NEX does not share calendar data with third parties unless legally required or for system security.',
    title3Respects3: 'For cross-border data transfers, we will ensure compliance with applicable laws through contractual terms or certification mechanisms.',

    title4: 'Your Rights',
    title4Respects1: 'You may unbind your Microsoft account at any time via the Q-NEX Console to stop data synchronization.',

    title5: 'Important Notes',
    title5Respects1: 'Please ensure you have administrative rights or legal authorization for the Microsoft account you bind.',
    title5Respects2: 'Once unbound, Q-NEX will stop syncing new data, but historical data may be retained for a certain period as required by compliance obligations.',

    contactInformation: 'Contact Information',
    contactInformationContent: 'If you have any questions, please contact: info@qnextech.com',

  }
}



// WEBPACK FOOTER //
// ./src/lang/fr.js